import { render } from "./CourseList.vue?vue&type=template&id=da38cf4a&scoped=true"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"

import "./CourseList.vue?vue&type=style&index=0&id=da38cf4a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da38cf4a"]])

export default __exports__